import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee481148"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "headline"
}
const _hoisted_2 = {
  key: 1,
  class: "slots"
}
const _hoisted_3 = { class: "header-menu" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_share = _resolveComponent("share")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.is_app || _ctx.ios_app)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "header",
          style: _normalizeStyle({ background: `${_ctx.backgroundColor}`, color: `${_ctx.fontColor}` })
        }, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_icon, {
                    name: "arrow-left",
                    color: _ctx.fontColor,
                    size: "0.59rem",
                    onClick: _ctx.boBack
                  }, null, 8, ["color", "onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                class: _normalizeClass({ titleAcive: _ctx.title === true })
              }, {
                default: _withCtx(() => [
                  (_ctx.title != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.title), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "center", {}, undefined, true)
                      ]))
                ]),
                _: 3
              }, 8, ["class"]),
              _createVNode(_component_van_col, null, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "right", {}, undefined, true),
                  (_ctx.menuState)
                    ? (_openBlock(), _createBlock(_component_van_icon, {
                        key: 0,
                        name: "ellipsis",
                        size: "0.59rem",
                        onClick: _ctx.openMenu,
                        id: "menuName"
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.shareState)
                    ? (_openBlock(), _createBlock(_component_van_icon, {
                        key: 1,
                        name: 'https://image.kilimall.com/kenya/new_wap/shop/ic_share_black@2x.png'.webpFilters()
,
                        size: "0.59rem",
                        onClick: _ctx.transmitPopup
                      }, null, 8, ["name", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              })
            ]),
            _: 3
          }),
          _withDirectives(_createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id,
                onClick: _withModifiers(($event: any) => (_ctx.jumpKip(item.url)), ["stop"])
              }, [
                _createVNode(_component_van_icon, {
                  name: item.icon,
                  color: "#000",
                  size: "22px"
                }, null, 8, ["name"]),
                _createElementVNode("span", null, _toDisplayString(item.title), 1)
              ], 8, _hoisted_4))
            }), 128)),
            _renderSlot(_ctx.$slots, "menu", {}, undefined, true),
            _hoisted_5
          ], 512), [
            [_vShow, _ctx.menuShow]
          ]),
          _createVNode(_component_share, {
            onShareShow: _ctx.shareShow,
            modelValue: _ctx.showShare,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showShare) = $event))
          }, null, 8, ["onShareShow", "modelValue"])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.is_app || _ctx.ios_app)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
      : _createCommentVNode("", true)
  ], 64))
}